import { useQuery } from '@tanstack/react-query';

export type AdminImportRequestItem = {
  id: number;
  status: 'pending' | 'done' | string;
  outer_job_post_id: number;
  organization_id: number;
  job_source_id: number;
  outer_job_post_title: string | null;
  outer_job_post_url: string | null;
  provided_job_post_title: string | null;
  company_name: string | null;
  created_at: string;
  updated_at: string;
};

type AdminImportRequestItemsResponse =
  | AdminImportRequestItem[]
  | {
      data?: AdminImportRequestItem[];
    };

const normalizeItems = (payload: AdminImportRequestItemsResponse): AdminImportRequestItem[] => {
  if (Array.isArray(payload)) {
    return payload;
  }
  return payload.data ?? [];
};

export default function useFetchAdminImportRequestItems(importRequestId: number | null) {
  return useQuery({
    queryKey: ['admin', 'import_requests', importRequestId, 'items'],
    queryFn: async () => {
      if (!importRequestId) return [];
      const response = await fetch(`/admin/api/import_requests/${importRequestId}/items`);
      if (!response.ok) {
        throw new Error('インポートリクエスト項目の取得に失敗しました');
      }
      const data: AdminImportRequestItemsResponse = await response.json();
      return normalizeItems(data);
    },
    enabled: !!importRequestId,
  });
}
